import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import './index.css';
import '@csstools/normalize.css';
import reportWebVitals from './reportWebVitals';
import AppRoutes from '@/routes/AppRoutes';
import { Auth0Provider } from '@auth0/auth0-react';
import { Auth0StatusWrapper } from './components/Auth0StatusWrapper/Auth0StatusWrapper';
import { store } from '@/reduxStore/rootReducer';
import { Provider } from 'react-redux';
import SystemNotificationController from './components/SystemNotificationsController/SystemNotificationsController';
import AuthorizedApolloProvider from '@/services/graphql/AuthorizedApolloProvider';
import PermissionsProvider from '@/components/PermissionsProvider/PermissionsProvider';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './GlobalStyle';
import { DocStyles } from './pages/docsApiPage/helpers/DocStyles';
import { useThemeMode } from '@/hooks/useThemeMode';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const publicRoutes = ['remittance', 'error-500', 'auth-error'];
const isPublicRoute = publicRoutes.indexOf(window.location.pathname.split('/')[1]) > -1;

document.fonts.onloading = (event) => {
    const elements = document.getElementsByClassName('material-symbols-sharp');

    Array.from(elements).forEach((element) => {
        element.classList.add('loading');
    });
};

document.fonts.onloadingdone = (event) => {
    const elements = document.getElementsByClassName('material-symbols-sharp');

    Array.from(elements).forEach((element) => {
        element.classList.remove('loading');
    });
};

const App = () => {
    const { theme, mode, preference, setPreference, toggleTheme } = useThemeMode();

    return (
        <Provider store={store}>
            <ConfigProvider
                // todo darkmode - remove this
                theme={{
                    components: {
                        Table: {
                            borderRadius: 0,
                            headerBorderRadius: 0,
                        },
                        Dropdown: {
                            borderRadiusLG: 0,
                            borderRadiusSM: 0,
                        },
                        Select: {
                            controlHeight: 42,
                            selectorBg: 'rgb(236, 240, 243)',
                            colorBorder: 'rgba(217, 217, 217, 0)',
                            colorPrimaryHover: 'rgb(4, 189, 215)',
                            fontSize: 16,
                            fontSizeIcon: 16,
                        },
                    },
                }}
            >
                {/* @ts-ignore - extending theme with runtime props */}
                <ThemeProvider theme={{ ...theme, toggleTheme, mode, preference, setPreference }}>
                    <div>
                        <GlobalStyle />
                        <DocStyles />
                        {isPublicRoute ? (
                            <AppRoutes />
                        ) : (
                            <Auth0Provider
                                domain={import.meta.env.VITE_AUTH0_DOMAIN as string}
                                clientId={import.meta.env.VITE_AUTH0_CLIENT_ID as string}
                                authorizationParams={{
                                    redirect_uri: window.location.origin,
                                    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
                                }}
                                useRefreshTokens
                                useRefreshTokensFallback
                                cacheLocation="localstorage"
                            >
                                <Auth0StatusWrapper>
                                    <PermissionsProvider>
                                        <AuthorizedApolloProvider>
                                            <AppRoutes />
                                            <SystemNotificationController />
                                        </AuthorizedApolloProvider>
                                    </PermissionsProvider>
                                </Auth0StatusWrapper>
                            </Auth0Provider>
                        )}
                    </div>
                </ThemeProvider>
            </ConfigProvider>
        </Provider>
    );
};

root.render(
    <>
        <App />
    </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
